import { render, staticRenderFns } from "./typeclassxq.vue?vue&type=template&id=9514ce02&scoped=true"
import script from "./typeclassxq.vue?vue&type=script&lang=js"
export * from "./typeclassxq.vue?vue&type=script&lang=js"
import style0 from "./typeclassxq.vue?vue&type=style&index=0&id=9514ce02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9514ce02",
  null
  
)

export default component.exports